
import * as classNames from "classnames"
import { AddCommentFormRenderProps } from "../../article/componentas/articleComments/addCommentFormWrapper";
import { disablePageRefresh, enablePageRefresh } from "../../../siteWidgets/siteWidgetUtils";
import { getTranslation } from "../../article/componentas/articleComments/translations";



interface AddCommentFormProps {
    props: AddCommentFormRenderProps
}

export class AddCommentFormUIGalhed extends React.Component<AddCommentFormProps, {}> {
    private getTermsLinkByLang = () => {
        const { lang } = this.props.props
        if (lang === "he") return "https://www.ynet.co.il/article/bkswwa3sn";
        else if (lang === "ru") return "https://www.vesty.co.il/articles/0,7340,L-4867560,00.html";
        else return "https://www.ynetnews.com/article/bkh7s3p7t"
    }

    private onConfirmAlertBtnPress = () => {
        const { closeAlert, resetFormData, handleCloseCommentForm } = this.props.props
        closeAlert()
        handleCloseCommentForm()
        resetFormData()
    }

    handleInputFocus = () => {
        disablePageRefresh()
    }

    handleInputOutOfFocus = () => {
        enablePageRefresh()
    }


    render() {
        const { isAddCommentFormVisible, isSent, title, name, email, comment, showAlert, formType, shouldTitleBeHidden,
            lang, alertBeforeClosing, handleCloseCommentForm, closeAlert, onInputChanged, handleCommentSend, isFirstComment } = this.props.props
        const AddCommentFormClasses = classNames({
            "AddCommentFormGalhed": true,
            "fadeIn": isAddCommentFormVisible,
            "hide": !isAddCommentFormVisible,
        })
        let term1 = " אין לשלוח תגובות הכוללות מידע המפר את";
        let term2 = "תנאי השימוש של Ynet";
        let term3 = " לרבות דברי הסתה, דיבה וסגנון החורג מהטעם הטוב.";
        if (lang === "en") {
            term1 = "The commenter agrees to the privacy policy of Ynet News and agrees not to submit comments that violate the ";
            term2 = "terms of use";
            term3 = ", including incitement, libel and expressions that exceed the accepted norms of freedom of speech.";
        }
        if (lang === "ru") {
            term1 = "Автор комментария принимает Условия конфиденциальности Вести и соглашается не публиковать комментарии, нарушающие ";
            term2 = "Правила использования";
            term3 = ",  в том числе подстрекательство, клевету и выходящее за рамки приемлемого в определении свободы слова.";
        }
        return (
            <div className={AddCommentFormClasses}>
                <div className="AddCommentForm" >
                    {!isSent &&
                      <>
                            {!isFirstComment && <button className="closeBtnWrapper" title={getTranslation(lang, "Close(Order Male)")} onClick={e => alertBeforeClosing()}></button>}
                            {!isFirstComment && !shouldTitleBeHidden && <div className="topTitleWrapper">
                                <span className="formTitle"> {formType === "REPLY" ? getTranslation(lang, "Add New Comment To Comment") : getTranslation(lang, "New Comment(premium)")} </span>
                            </div>}



                            <input
                                className="userDetailsInput inputStyle"
                                maxLength={20}
                                value={name}
                                name="commenterName"
                                placeholder={getTranslation(lang, "Full Name")}
                                onChange={(e) => onInputChanged(e, "name")}
                                onFocus={this.handleInputFocus}
                                onBlur={this.handleInputOutOfFocus}
                            />

                            <textarea
                                className="comment inputStyle"
                                type="text" maxLength={4000}
                                value={comment}
                                name="commentContent"
                                resize="vertical"
                                placeholder={getTranslation(lang, "Write your dedication")}
                                onChange={(e) => onInputChanged(e, "comment", true)}
                                onFocus={this.handleInputFocus}
                                onBlur={this.handleInputOutOfFocus}
                            >
                            </textarea>
                            <div className="termsOfService">
                                {term1}
                                <a href={this.getTermsLinkByLang()} target="_blank" title={getTranslation(lang, "terms of use")} style={{ margin: "auto 5px" }} >{term2}</a>
                                {term3}
                            </div>
                           
                                    <button className="sendBtn" id="addCommentSendButton" title={getTranslation(lang, "Send your dedication")} onClick={e => handleCommentSend()}>
                                        <span>{getTranslation(lang, "Send your dedication")}</span>
                                    </button>
                              
                       </> }

                    {isSent && <div className="commentSentMessageWrapper">
                        <div className="thankYouWrapper">
                         
                            <div className="thankYou"><strong >{getTranslation(lang, "Thank you for adding to the memory wall")},</strong> <span>{getTranslation(lang, "Your response has been submitted for approval and will be published subject to the system's considerations.")}</span></div>
                            <button className="closeTextWrapper closeIcon" title={getTranslation(lang, "Close")} onClick={this.onConfirmAlertBtnPress}>

                            </button>
                        </div>
                    </div>}
                </div>

            </div>
        )
    }
}